import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=0d75050b&scoped=true"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=0d75050b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d75050b",
  null
  
)

export default component.exports